
import { Options, Prop, Vue, Watch } from "vue-property-decorator";
import * as jiekou from "@/api/safecheck";

@Options({})
export default class extends Vue {
  @Prop() private submitform!: any;
  private show = false;
  private flag = false;
  private personName = "";
  private refreshing = false;
  private checkList: any[] = [];
  private loading = false;
  private finished = false;
  private result = "";
  private fieldValue = "";
  private userId = "";

  @Watch("personName")
  onPersonNameChanged(newValue: string, oldValue: string) {
    this.refreshing = true;
    this.onRefresh();
  }
  @Watch("result")
  onResultChanged(newValue: string, oldValue: string) {
    this.flag = true;
  }

  mounted() {
    this.result = this.$store.state.project.qualitysafe.changePersonId
      ? this.$store.state.project.qualitysafe.changePersonId
      : "";
    this.fieldValue = this.$store.state.project.qualitysafe.changePersonName
      ? this.$store.state.project.qualitysafe.changePersonName
      : "";
  }

  protected showPopup() {
    this.show = true;
  }

  protected closePopup() {
    this.show = false;
  }

  protected onLoad() {
    setTimeout(() => {
      if (this.refreshing) {
        this.checkList = [];
        this.refreshing = false;
      }
      jiekou
        .pageListUser({
          pageNum: parseInt(this.checkList.length / 20 + "") + 1,
          pageSize: 20,
          projectId: this.$store.state.project.projectinfo.projectId,
          name: this.personName,
        })
        .then((res) => {
          this.checkList = [...this.checkList, ...res.data.records];
          this.loading = false;
          if (this.checkList.length >= res.data.total) {
            this.finished = true;
          }
        });
    }, 500);
  }

  protected onFinish() {
    let index = this.checkList.findIndex((item) => {
      if (item.userId === this.result) {
        return true;
      }
    });
    this.fieldValue = this.checkList[index].name;
    this.show = false;
    this.$emit("selectPerson", this.result);
    this.$emit("selectPersonName", this.fieldValue);
  }

  onRefresh() {
    this.finished = false;
    this.loading = true;
    this.onLoad();
  }
}
